import { Flex, Text } from "@ui"
import { Button } from "@ui/Button"
import type { FC } from "react"

type ErrorScreenProps = {
  title: string
  message: string
  action: { label: string; onClick: () => void }
}

/**
 * Shared full-screen error view used by the root error boundary and `/error`.
 * Each surface supplies its own recovery action (e.g. reload to re-check
 * access, or retry login).
 */
export const ErrorScreen: FC<ErrorScreenProps> = ({
  title,
  message,
  action,
}) => (
  <Flex
    width="full"
    flexDirection="column"
    alignItems="center"
    color="error"
    gap="lg"
  >
    <Text textAlign="center">{title}</Text>
    <Text textAlign="center">{message}</Text>
    <Button onClick={() => action.onClick()}>{action.label}</Button>
  </Flex>
)
